import {css} from 'lit'; export default css`.settings-header{border-bottom:1px solid var(--goto-border-color-default);margin-top:var(--goto-spacing-07);padding-left:var(--goto-spacing-07);padding-bottom:var(--goto-spacing-04)}`;
    